/**
 * @generated SignedSource<<df6da8b4186a7e9eb9525c085fc67bfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceSignalEditMainCancelPublishMutation$variables = {
  id: string;
};
export type WorkspaceSignalEditMainCancelPublishMutation$data = {
  readonly signalWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledPublishAt: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly status: WorkspaceSignalStatus;
    };
  };
};
export type WorkspaceSignalEditMainCancelPublishMutation$rawResponse = {
  readonly signalWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledPublishAt: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly status: WorkspaceSignalStatus;
    };
  };
};
export type WorkspaceSignalEditMainCancelPublishMutation = {
  rawResponse: WorkspaceSignalEditMainCancelPublishMutation$rawResponse;
  response: WorkspaceSignalEditMainCancelPublishMutation$data;
  variables: WorkspaceSignalEditMainCancelPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainCancelPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainCancelPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8513f0f007cb0af5e69bc304ca57ca71",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainCancelPublishMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditMainCancelPublishMutation(\n  $id: ID!\n) {\n  signalWorkspace(id: $id) {\n    updateScheduledPublishAt {\n      id\n      status\n      scheduledPublishAt {\n        isoString\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "fc6b6fcf5802a48c0263d39b8068b189";

export default node;
